import { IListDetailsDto } from "../../interface/dto/list-details.dto";
import {
    ListDetailsActionType,
    IListDetailsAction,
} from "./list-details.actions";

export interface IListDetailsState {
    isLoading: boolean;
    error?: string;
    details?: IListDetailsDto;
    notFound?: boolean;
}

const initState: IListDetailsState = {
    isLoading: false,
    details: undefined,
    notFound: false,
};

export const listDetailsReducer = (
    state = initState,
    action: IListDetailsAction,
) => {
    switch (action.type) {
        case ListDetailsActionType.LIST_DETAILS_GET:
            return {
                ...state,
                isLoading: true,
                error: undefined,
                details: undefined,
                notFound: false,
            };
        case ListDetailsActionType.LIST_DETAILS_GET_ERROR:
            return { ...state, error: action.payload.error, isLoading: false };
        case ListDetailsActionType.LIST_DETAILS_GET_SUCCESS:
            return {
                ...state,
                details: action.payload,
                isLoading: false,
            };
        case ListDetailsActionType.LIST_TRACK:
            return {
                ...state,
                details: {
                    ...state.details!,
                    isTracked: action.payload.track,
                },
                error: undefined,
            };
        case ListDetailsActionType.LIST_TRACK_ERROR:
            return { ...state, error: action.payload.error };
        case ListDetailsActionType.LIST_TRACK_SUCCESS:
            return {
                ...state,
            };
        case ListDetailsActionType.LIST_DETAILS_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                notFound: true,
            };
        default:
            return state;
    }
};
